(function () {

    'use strict';

    angular.module('asys')
        .component('asysErgebnisZeileBausteinCombobox', {
            require: {
                formCtrl: '^^form'
            },
            bindings: {
                disabled: '<aezbcDisabled',
                type: '@aezbcType',
                value: '<aezbcValue',
                field: '<aezbcField',
                form: '@?aezbcForm',
                label: '@?aezbcLabel',
                data: '<aezbcData',
                dataProperties: '@aezbcDataProperties',
                change: '&aezbcChange',
                options: '<aezbcOptions'
            },
            templateUrl: 'ergebnis/partials/ergebnisZeileBausteinCombobox.html',
            controller: ErgebnisZeileBausteinComboboxController,
            controllerAs: 'ergZeileBausteinComboboxVm'
        });

    ErgebnisZeileBausteinComboboxController.$inject = [
        '$scope',
        '$filter',
        '$timeout',
        'lodash',
        'numbro',
        'MoneyUtilsService',
        'MiscUtilsService',
        'FormatUtilsService'
    ];
    function ErgebnisZeileBausteinComboboxController($scope, $filter, $timeout, _, numbro, MoneyUtilsService, MiscUtilsService, FormatUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.getText = getText;

        function activate() {
            vm.gridLayoutCss = vm.options.grid || {};
            vm.properties = $scope.$eval(vm.dataProperties) || {};
            vm.trackBy = vm.properties.trackBy ? 'value.' + vm.properties.trackBy : null;
            vm.placeholder = getPlaceholder();
            vm.validationOptions = vm.options.validation || {};
        }

        function onChanges() {
            activate();
        }

        function onInit() {
            vm.options = vm.options || {};
            vm.fieldPartialUrl = 'ergebnis/partials/combobox/combobox' + _.upperFirst(vm.type) + '.html';

            vm.fieldName = [
                vm.field.name,
                MiscUtilsService.guid('#')
            ].join('_');

            if (vm.options.autoSetValueIfInvalid) {
                $scope.$watch(function () {
                    return _.get(vm.formCtrl, vm.fieldName + '.$valid');
                }, function (valid) {
                    var fieldCtrl = vm.formCtrl[vm.fieldName];

                    if (!_.isUndefined(valid) && !valid) {
                        fieldCtrl.$setViewValue(getAutoSetValue());
                        fieldCtrl.$render();

                        if (fieldCtrl.$$element && fieldCtrl.$$element[0] && angular.isFunction(fieldCtrl.$$element[0].focus)) {
                            fieldCtrl.$$element[0].focus();
                        }
                    }
                });
            }

            activate();
        }

        function _round(value, precision) {
            var multiplier = Math.pow(10, precision || 0);
            return Math.round(value * multiplier) / multiplier;
        }

        function getPlaceholder() {
            var min,
                max,
                recommended;

            if (vm.type === 'inputMoney') {
                if (MiscUtilsService.isNotEmpty(_.get(vm.field, 'min'))) {
                    min = $filter('numberString')(_.get(vm.field, 'min'), 0);
                }

                if (MiscUtilsService.isNotEmpty(_.get(vm.field, 'max'))) {
                    max = $filter('numberString')(_.get(vm.field, 'max'), 0);
                }

                if (MiscUtilsService.isNotEmpty(_.get(vm.field, 'recommended'))) {
                    recommended = $filter('numberString')(_.get(vm.field, 'recommended'), 0);
                }
            }

            return {
                required: [recommended],
                min: [min],
                'min, minlength': [min],
                max: [max],
                'max, maxlength': [max],
                'min, max': [
                    min,
                    max
                ]
            };
        }

        function getAutoSetValue() {
            var fieldCtrl = _.get(vm.formCtrl, vm.fieldName) || {},
                field = vm.field || {},
                val;

            if (_.get(fieldCtrl, '$error.min')) {
                val = numbro(_round(field.min, field.precision)).format(field.mask);
            } else if (_.get(fieldCtrl, '$error.max')) {
                val = numbro(_round(field.max, field.precision)).format(field.mask);
            } else if (_.get(fieldCtrl, '$error.required')) {
                val = numbro(_round(field.recommended, field.precision)).format(field.mask);
            }

            return val;
        }
        function getText(value) {
            if (!value) {
                return null;
            }

            var text;

            if (_.get(vm.properties, 'bezeichnung')) {
                text = value[vm.properties.bezeichnung];
            } else {
                text = value;
            }

            if (MoneyUtilsService.isMoneyObject(text)) {
                text = $filter('moneyString')(text, 'code', '+', 0);
            }

            if (_.size(vm.data) === 1 && _.get(vm.properties, 'bezeichnungText')) {
                text = FormatUtilsService.replace(_.get(vm.properties, 'bezeichnungText'), text);
            }

            return text;
        }
    }

})();
